import type { IdealItemDto } from '@bk/contracts';

const LOOK = {
  legge: { text: 'Obbligatorio', cls: 'bg-violet-100 text-violet-700' },
  prassi: { text: 'Buona prassi', cls: 'bg-sky-100 text-sky-800' },
  crescere: { text: 'Per crescere', cls: 'bg-amber-100 text-amber-800' },
  web: { text: 'Dal web', cls: 'bg-blue-100 text-blue-700' },
} as const;

/**
 * Perché una voce c'è (ADR 0087): «Obbligatorio» (la legge, con la norma), «Buona prassi» (con la fonte) o «Per
 * crescere» (con l'obiettivo del titolare). Prima la parola semplice, il riferimento al passaggio del mouse; con
 * `detail` anche scritto accanto, in piccolo. Le voci di prima, senza etichetta, valgono come obbligatorie se lo erano.
 */
export function ItemBase({ v, detail = false }: { v: Pick<IdealItemDto, 'base' | 'riferimento' | 'obbligatorio' | 'norma'>; detail?: boolean }) {
  const base = v.base ?? (v.obbligatorio ? 'legge' : null);
  if (!base) return null;
  const ref = v.riferimento ?? (base === 'legge' ? v.norma : null) ?? null;
  const look = LOOK[base];
  return (
    <span className="ml-1 inline-flex items-baseline gap-1 align-[1px]">
      <span className={`whitespace-nowrap rounded-md px-1.5 text-[10.5px] font-semibold ${look.cls}`} title={ref ?? undefined}>
        {look.text}
      </span>
      {detail && ref && <span className="text-[11px] text-ink/45">{ref}</span>}
    </span>
  );
}
